import { Injectable } from '@angular/core';
import { RestApi } from './rest.api';
import { Router } from '@angular/router';
import { AutoLoginStrategy } from './AutoLoginStrategy';
import { Observable } from 'rxjs';

@Injectable()
export class AutoLoginClient {
  private profile: any;

  constructor(private _api: RestApi, private _router: Router) { }

  public configuration(): Observable<any> {
    return this._api.get('api/auth/autoLogin/verify/configuration')
      .map(res => {
        const data = res;
        this.profile = data;
        return data;
      })
      .catch((err) => Observable.throw(err._body));
  };

  public getProfile(): Observable<any> {
    return this._api.get('api/auth/autoLogin/profile')
      .map(res => {
        const data = res;
        this.profile = data;
        return data;
      })
      .catch((err) => Observable.throw(err._body));
  };

  public login(userName: string, password: string): Observable<any> {
    const body = { Username: userName, Password: password }
    return this._api.post('api/auth/autoLogin/logIn', body)
      .map(response => {
        if(response && response.autoLoginCodeMessage === 'LoginSucessful'){
          const data = response;
          this.profile = data.autoLoginUser;
          this._api.setAuthorizationToken(this.profile.verificationCode);
          AutoLoginStrategy.setToken(this.profile.verificationCode);
          AutoLoginStrategy.setRefreshToken(this.profile.refreshToken);
        }
        return response;
      })
      .catch((err) => Observable.throw(err._body));
  };

  public refreshToken(): Observable<any> {
    const body = { };
    this._api.setAuthorizationToken(AutoLoginStrategy.getRefreshToken());
    return this._api.post('api/auth/autoLogin/token/refresh', body)
      .map(response => {
        if(response){
          this._api.setAuthorizationToken(response.accessToken);
          AutoLoginStrategy.setToken(response.accessToken);
          AutoLoginStrategy.setRefreshToken(response.refreshToken);
        }
        return response.accessToken;
      })
      .catch((err) => Observable.throw(err._body));
  };

  public async logOut () {
    await this._api.post('api/auth/autoLogin/logOut', '').toPromise();
  };

  public validateCode(code: string): Observable<any> {
    const validationCode = { verificationToken : code };
    return this._api.post('api/auth/autoLogin/codes/validate', validationCode)
      .map(response => {
        return response;
      })
      .catch((err) => Observable.throw(err._body));
  };

  public changePasword(password: string, code: string): Observable<any> {
    const body = { newPassword: password, verificationToken : code }
    return this._api.post('api/auth/autoLogin/password/change', body)
      .map(response => {
        return response;
      })
      .catch((err) => Observable.throw(err._body));
  }

  public sendVerificationCode(userName: string): Observable<string> {
    const body = { Username: userName }
    return this._api.post('api/auth/autoLogin/codes/send', body)
      .map(response => {
        return response;
      })
      .catch((err) => Observable.throw(err._body));
  }

  public changeAdministrator(userName: string): Observable<string> {
    const body = { userName };
    return this._api.post('api/auth/autoLogin/administrator/change', body)
      .map(response => {
        return response;
      })
      .catch((err) => Observable.throw(err._body));
  }

  public getUserProfile(): IUserProfile {
    return {
      name: this.profile.username.split('@')[0],
      email: this.profile.username
    };
  }
}
